angular.module('filters.myAlert', [])
  .filter('myAlert', function () {
    return function(alerts) {
      return devex.util.findMyAlert(alerts);
    };
  });
